import { BaseError, type Hash, type TransactionReceipt } from 'viem'
import { waitForTransactionReceipt } from 'viem/actions'
import type { Config } from 'wagmi'

// viem 2.56.5 does not publicly export its reverted-receipt error.
export class TransactionReceiptRevertedError extends BaseError {
  receipt: TransactionReceipt

  constructor({ receipt }: { receipt: TransactionReceipt }) {
    super(`Transaction with hash "${receipt.transactionHash}" reverted.`, {
      name: 'TransactionReceiptRevertedError',
    })
    this.receipt = receipt
  }
}

export async function waitForTransactionSuccess(config: Config, { hash }: { hash: Hash }) {
  const client = config.getClient()
  const receipt = await waitForTransactionReceipt(client, { hash, timeout: 0 })
  if (receipt.status === 'reverted') {
    throw new TransactionReceiptRevertedError({ receipt })
  }
  return receipt
}
